import React from "react";
import HeaderToolbar from "../../components/HeaderToolbar";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useRef } from "react";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../Util/CommonUtils";
import { useDispatch } from "react-redux";
import {
  addVideo,
  getSafetyVideo,
  updateSafetyVideo,
} from "../../slices/SafetyVideoSlice";
import { useEffect } from "react";
import { ReactComponent as ProfileEditIcon } from "../../assets/ProfileEditIcon.svg";
import { Edit } from "@material-ui/icons";

import EditIcon from "../Person/EditIcon";

function SafetyVideo() {
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const fileInputRef = useRef(null);
  const [videoFile, setVideoFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState();
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState([]);

  const [payload, setPayload] = useState({
    id: "",
    fileName: "",
    description: "",
    videoCaption: "",
  });

  const [error, setError] = useState({
    fileName: false,
    description: false,
    videoCaption: false,
  });

  useEffect(() => {
    loadCompanySafetyVideos();
  }, []);

  const loadCompanySafetyVideos = () => {
    dispatch(getSafetyVideo())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000" && res.data) {
          setData(res.data[0]);
          setEdit(res.data.length === 0 ? true : false);
          setSelectedFileName(res.data[0]?.fileName);
          setPayload({
            ...payload,
            id: res.data[0]?.id,
            videoCaption: res.data[0]?.videoCaption,
            description: res.data[0]?.description,
            fileName: res.data[0]?.fileName,
          });
        }
      });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handleVideoFile = () => {
    fileInputRef.current.click();
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith("video/")) {
        Toast("Only video files are allowed!", "error");
        event.target.value = "";
        return;
      }
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        Toast(t("FILE_SIZE_ERROR"), "error");
        return;
      }
      setVideoFile(file);
      setSelectedFileName(file.name);
      setPayload({
        ...payload,
        fileName: file.name,
      });
    }
  };
  const removeFile = () => {
    setSelectedFileName("");
    setVideoFile();
    setPayload({
      ...payload,
      fileName: "",
    });
    fileInputRef.current.value = "";
  };

  const handleSumbit = () => {
    if (CommonUtil.isEmptyString(selectedFileName)) {
      Toast(t("SELECT_VIDEO_ERROR"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(payload.videoCaption)) {
      Toast(t("VIDEO_CAPTION_ERROR"), "error");
      setError({ ...error, videoCaption: true });
      return;
    }
    if (CommonUtil.isEmptyString(payload.description)) {
      Toast(t("VIDEO_DESCRIPTION"), "error");
      setError({ ...error, description: true });
      return;
    }
    const formData = new FormData();
    for (const key in payload) {
      if (payload[key] != null) {
        formData.append(key, payload[key]);
      }
    }
    if (videoFile !== null || videoFile !== undefined) {
      formData.append("file", videoFile);
    }
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    if (!data) {
      dispatch(addVideo(formData))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4100") {
            setEdit(false);
            setData(res.data);
            Toast(res.message, "success");
            return;
          } else {
            setEdit(false);
            Toast(res.message, "error");
            return;
          }
        });
    } else {
      dispatch(updateSafetyVideo(formData))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4102") {
            setEdit(false);
            Toast(res.message, "success");
            return;
          } else {
            setEdit(false);
            Toast(res.message, "error");
            return;
          }
        });
    }
  };

  const handleClickEdit = () => {
    setEdit(!edit);
  };

  const handleCancel = () => {
    loadCompanySafetyVideos();
  };

  return (
    <>
      <HeaderToolbar title={t("VIDEO_UPLOAD")} />
      <Paper
        style={{
          backgroundColor: darkMode ? "rgb(14, 42, 65)" : "rgb(255, 255, 255)",
          height: "calc(100vh - 150px)",
          marginTop: "15px",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Box>
          <Grid>
            <div
              style={{
                // backgroundColor: darkMode ? "#0E2A41" : "#F2F2F6",
                marginRight: "0px",
                display: "flex",
                justifyContent: "end",
                paddingRight: "24px",
                paddingTop: "16px",
              }}
            >
              <IconButton
                onClick={handleClickEdit}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Tooltip
                  title={
                    <Typography fontSize={12} fontWeight={500}>
                      {t("COMMON005")}
                    </Typography>
                  }
                >
                  {/* {<ProfileEditIcon className="profileEditIcon" />} */}
                  <EditIcon />
                </Tooltip>
              </IconButton>
            </div>
          </Grid>
        </Box>
        <Box
          style={{
            flex: 1,
            // paddingTop: "24px",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              style={{
                paddingLeft: "50px",
                paddingRight: "35px",
              }}
            >
              <Box
                style={{
                  padding: "20px",
                  backgroundColor: darkMode ? "#021c31" : "#FBFBFB",
                  height: "",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  style={{
                    paddingBottom: "16px",
                    paddingTop: "10px",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      color: darkMode ? "white" : "#000000",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {t("UPLOAD_VIDEO_FILE")}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      color: darkMode ? "white" : "#000000",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {t("UPLOAD_VIDEO_FILE_DESCRIPTION")}
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      style={{
                        border: "2px dashed #8EC9F1",
                        borderRadius: "8px",
                        height: "195px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "68%",
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: "bold",
                          marginBottom: "4px",
                          color: darkMode ? "white" : "#000000",
                          paddingTop: "10px",
                        }}
                      >
                        {t("SELECT_VIDEO")}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: darkMode ? "white" : "#000000",
                        }}
                      >
                        {t("VIDEO_FORMATS")}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: darkMode ? "white" : "#000000",
                        }}
                      >
                        {t("VIDEO_SIZE")}
                      </Typography>
                      <SubmitButtons
                        variant="contained"
                        onClick={handleVideoFile}
                        disabled={!edit}
                        sx={{
                          marginTop: "20px",
                          "&.Mui-disabled": {
                            backgroundColor: "#ccc",
                            color: "#666",
                          },
                        }}
                      >
                        <Typography
                          variant="body1"
                          style={{ textTransform: "none" }}
                        >
                          {t("SELECT_VIDEO_BUTTON")}
                        </Typography>
                        <input
                          type="file"
                          accept="video/*"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={onFileChange}
                          disabled={!edit}
                        />
                      </SubmitButtons>
                      {selectedFileName && (
                        <>
                          <Stack
                            direction={"row"}
                            spacing={2}
                            sx={{
                              mt: "16px",
                            }}
                          >
                            <Tooltip title={selectedFileName}>
                              <Typography
                                variant="body2"
                                style={{
                                  color: darkMode ? "white" : "#000000",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "200px",
                                }}
                              >
                                {selectedFileName}
                              </Typography>
                            </Tooltip>

                            <Tooltip title={t("buttonInviteSentClear")}>
                              <IconButton
                                onClick={removeFile}
                                disabled={!edit}
                                sx={{
                                  color: "red",
                                  padding: "0px",
                                  marginTop: "10px",
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {/* </IconButton> */}
                          </Stack>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid
                container
                spacing={2}
                style={{
                  paddingTop: "14px",
                  width: "85%",
                }}
              >
                <Grid item sm={12}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      color: darkMode ? "white" : "#242424",
                    }}
                  >
                    {t("VIDEO_CAPTION")}
                  </Typography>
                </Grid>
                <Grid item sm={12}>
                  <CustomTextfield
                    label={t("VIDEO_CAPTION_LABEL")}
                    error={error.videoCaption}
                    name="videoCaption"
                    value={payload.videoCaption}
                    disabled={!edit}
                    handleChange={(e) => handleChange(e)}
                    required={true}
                    autoComplete="off"
                    inputProps={{ maxLength: 50 }}
                    InputProps={{
                      style: {
                        color: darkMode ? "#fff" : "black",
                      },
                    }}
                  />
                </Grid>

                <Grid item sm={12}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      color: darkMode ? "white" : "#242424",
                    }}
                  >
                    {t("ATYPE009")}
                  </Typography>
                </Grid>
                <Grid item sm={12}>
                  <CustomTextfield
                    label={t("ATYPE009")}
                    error={error.description}
                    name="description"
                    disabled={!edit}
                    value={payload.description}
                    handleChange={(e) => handleChange(e)}
                    required={true}
                    autoComplete="off"
                    multiline
                    rows={5}
                    InputProps={{
                      style: {
                        color: darkMode ? "#fff" : "black",
                      },
                    }}
                    inputProps={{ maxLength: 300 }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {edit && (
          <Box
            style={{
              padding: "0px 24px 24px 0px",
            }}
          >
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                paddingRight: "6px",
              }}
            >
              <Grid item>
                <SubmitButtons
                  variant="contained"
                  onClick={handleSumbit}
                  disabled={!edit}
                >
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("COMMON007")}
                  </Typography>
                </SubmitButtons>
              </Grid>
              <Grid item>
                <CancelButtons
                  variant="contained"
                  color="secondary"
                  onClick={handleCancel}
                  disabled={!edit}
                >
                  <Typography variant="body1" style={{ textTransform: "none" }}>
                    {t("COMMON008")}
                  </Typography>
                </CancelButtons>
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>
    </>
  );
}

export default SafetyVideo;
